// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clapperboardIcon from "@/assets/icons/clapperboard.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClapperboardIconProps = Omit<IconProps, "name">;

export function ClapperboardIcon(props: ClapperboardIconProps): React.ReactNode {
  return <Icon name={clapperboardIcon} {...props} />;
}
